// @owners { team: patient-fulfillment }
import getDeliveriesForShipmentID from '~shared/features/delivery-info/selectors/getDeliveriesForShipmentID';
import { type DeliveryWithPrescription } from '~shared/features/delivery-info/types';
import { getSelectedPrescription } from '~shared/features/prescriptions/selectors/getSelectedPrescription';
import { UPCOMING_STATUSES } from '~shared/features/shipments/constants';
import { getShipmentWithID } from '~shared/features/shipments/selectors/getShipments';
import { useSelectorShared } from '~shared/store';
import { type DeliveryStatus, type ShipmentStatus } from '~shared/types';
import { useShipmentID } from '../../delivery-details';

export const useCanChangeAutoRefillStatus = ({ isPostCheckout }: { isPostCheckout: boolean }) => {
  const prescription = useSelectorShared(getSelectedPrescription);
  const { shipmentID } = useShipmentID();
  const shipment = useSelectorShared((state) => getShipmentWithID(state, { shipmentID }));
  const delivery: DeliveryWithPrescription | undefined = useSelectorShared(
    (state) => getDeliveriesForShipmentID(state, { shipmentID })[0],
  );
  const status: DeliveryStatus | ShipmentStatus = (!delivery ? 'canceled' : shipment?.status) ?? delivery?.status;

  if (!prescription) return { canChangeAutoRefillStatus: false };

  const isAutoRefillEligible = !!prescription.auto_refill_eligible;

  if (isPostCheckout) {
    return {
      canChangeAutoRefillStatus:
        isAutoRefillEligible && !delivery?.med_sync_status && [...UPCOMING_STATUSES, 'upcoming'].includes(status),
    };
  }

  return { canChangeAutoRefillStatus: isAutoRefillEligible };
};
